import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import Img from 'react-image';
import placeholder from './placeholder-image.png';
import Loader from 'oxyrion-ui/lib/Loader';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';

const MainWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const SelectedImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(550)};
  height: ${rem(450)};
  margin-bottom: ${rem(10)};
  // box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
`;

const Photos = styled.div`
  width: ${rem(550)};
  padding-right: ${rem(20)};
  transition: opacity 0.5s, max-height 1s;
`;

const MainImage = styled(Img)`
  max-height: ${rem(410)};
  max-width: ${rem(410)};
`;

const SmallImage = styled(Img)`
  height: ${rem(120)};
  margin: ${rem(15)};
  cursor pointer;
  :hover{
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.16);
  }
`;

const ShowMore = styled.div`
display: flex;
justify-content: center;
align-items: center;
cursor pointer;
height: ${rem(120)};
width: ${rem(120)};
:hover {
  text-decoration: underline;
}

`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class CatalogProductGallery extends React.Component {
  state = {
    showMore: false,
  };

  render() {
    const { images, selectedImage, onImageSelect, showMorePhotos } = this.props;
    const { showMore } = this.state;
    let selectedImagePath = '';

    if (images.length > 0) {
      if (selectedImage && images.find(i => i.name === selectedImage)) {
        selectedImagePath = images.find(i => i.name === selectedImage).path;
      } else {
        selectedImagePath = images.find(i => i.name === 'main')
          ? (selectedImagePath = images.find(i => i.name === 'main').path)
          : images[0].path;
      }
    }
    const otherPhotosPaths = images.map(i => i.path);

    return (
      <MainWrapper>
        <SelectedImageWrapper>
          <MainImage
            src={[`${baseURL}/images/400x0/${selectedImagePath}`, placeholder]}
            loader={
              <LoaderWrapper>
                <Loader />
              </LoaderWrapper>
            }
          />
        </SelectedImageWrapper>
        {showMorePhotos && (
          <Photos>
            {otherPhotosPaths
              .slice(0, !showMore ? 3 : otherPhotosPaths.length)
              .map(p => {
                return (
                  <SmallImage
                    onMouseOverCapture={() =>
                      onImageSelect(images.find(i => i.path === p).name)
                    }
                    src={`${baseURL}/images/277x233/${p}`}
                    alt={<div />}
                  />
                );
              })}
            {!showMore && otherPhotosPaths.length - 3 > 0 && (
              <ShowMore
                onClick={() =>
                  this.setState({
                    showMore: true,
                  })
                }
              >{`+${otherPhotosPaths.length - 3} ďalších`}</ShowMore>
            )}
          </Photos>
        )}
      </MainWrapper>
    );
  }
}

CatalogProductGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
  selectedImage: PropTypes.string,
  selectedImageIndex: PropTypes.number,
  onImageSelect: PropTypes.func,
  showMorePhotos: PropTypes.bool,
};

CatalogProductGallery.defaultProps = {
  images: [],
  selectedImage: 'main',
  selectedImageIndex: null,
  showMorePhotos: true,
  onImageSelect: () => {},
};

export default CatalogProductGallery;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/Gallery/index.jsx